<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
            <b-row class="col-md-12 lgtypelist mt-3">
                 
            <div class="col mx-1">
              <label>Gender</label>
                <b-form-group>
                  <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                    v-model="selected_segment_id"
                    id="selected_segment_id"
                    name="selected_segment_id"
                    placement="Select Gender"
                  >
                    <option :value="null">--Select Gender--</option>
                    <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                      segmentlist.segment_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">
              <label>Season</label>
               <b-form-group >
                  <b-form-select @change="showSubcategory(selected_collection_id)"
                    v-model="selected_collection_id"
                    id="selected_collection_id"
                    name="selected_collection_id"
                  >
                    <option :value="null">--Select Season--</option>
                    <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                      collection.collection_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">

              <label>Sub-category</label>
                 <b-form-group >
                  <b-form-select @change="getPoTypeList(sub_catid);"
                    v-model="sub_catid"
                    id="sub_catid"
                    name="sub_catid"
                  >
                    <option :value="null">--Select Sub-category--</option>
                    <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                      subcatarry.sub_cattitle
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div>
             <div class="col mx-1">
              <label>PO Type (PT)</label>
                <b-form-group >
                
                  <b-form-select
                    v-model="selected_po_id"
                    id="selected_po_id"
                    name="selected_po_id"
                  >
                    <option :value="null">--Select PO Type--</option>
                    <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                      polist.potype_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
            </div> 
            <div class="col mx-1">
              <label></label>
              <b-form-group>
               <b-button @click="searchData(brand_id)"
                      type="submit"
                      variant="primary"
                      class="px-4 pull-left mt-2"
                      >Search</b-button
                    >
                  <button
                    class="btn btn-sm btn-primary ml-3 mt-2 px-3 pb-2"
                    v-on:click="refresh()"
                    type="button"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                </b-form-group>
            </div> 
 
          </b-row>
          <hr>
            <!-- <label style="margin-left: 20px;">All Designs : </label>         
            <b-row class="boxto">     
       

                <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                 <router-link  :to="'/style_list/' +'ALL_Designs'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs reject">{{ALL_Designs}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="My Designs"> All Designs</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            </b-row>

            <hr style="height:30px"> -->



            <!-- Code For Files -->

            <label style="margin-left: 20px; margin-top:10px;">Files : </label>         
            <b-row class="boxto">     
            <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua"  >
                    <router-link :to="'/style_list/' + 'Measurment_Chart_Pending'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{Measurment_Chart_Pending}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">Measurement Chart Pending</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal" >
                <router-link  :to="'/style_list/' +'Measurement_Chart_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Measurement_Chart_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Measurement Chart Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>



              <b-col sm="6" lg="2" >

                <b-card no-body class="bg-def"  >
                    <router-link :to="'/style_list/' + 'TRC_Upload_Pending'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{TRC_Upload_Pending}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="PROTO Received">PROTO Received</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                <router-link  :to="'/style_list/' +'TRC_Uploaded'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{TRC_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TRC File Uploaded"> TRC File Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

                <b-col sm="6" lg="2" >
                <b-card no-body class="bg-red" >
                <router-link  :to="'/style_list/' +'TAT_Breached'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="TAT Breached">{{TAT_Breached}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="TAT Breached">TAT Breached</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
              
 
            
            </b-row>

            <hr style="height:30px">


          </b-card>
        </b-col>
      </b-row>
    </div>








  </div>
</div>
 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
const axios = require('axios');
export default {
  name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,
     ALL_Designs: 0,
    pending_for_approval: 0,
    Designapproved:0,
    designrejected: 0,


    Measurment_Chart_Pending: 0,
    Measurement_Chart_Uploaded: 0,
    TRC_Upload_Pending: 0,
    TRC_Uploaded: 0,
    TAT_Breached:0,
    access_token: '',
       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }],
      // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      sub_catid: "",
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result:[],
    }
  },
 
  created: function () {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)

    //this.sub_cat_id_arr = userInfo[0].subcat_assign;

    // this.displayDashboardData();
    // this.getBrandSegmentList();
  },
  mounted() {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    console.log('tempLocalStorage-------->',tempLocalStorage)
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        this.showCollection(userInfo[0].brand_assign,tempLocalStorage.selected_segment_id)
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.displayDashboardData();
    this.getBrandSegmentList();
  },

  methods: {
    
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
         
        const Obj = {
           user_id:userInfo[0].user_id,
           user_type:userInfo[0].user_type,
           brand_id: userInfo[0].brand_assign,
           segment_id: this.selected_segment_id ? this.selected_segment_id : null,
          collection_id: this.selected_collection_id ? this.selected_collection_id : null,
          sub_catid: this.sub_catid ? this.sub_catid : null,
          po_id: this.selected_po_id ? this.selected_po_id : null       
                 
                  }
        
      axios.post(`${CONSTANTS.API_URL}/getdashboardcountforfit_tech`,Obj)
                .then(response => {
                 var result = response.data
                 this.resultData = response.data.returnvalue[0];
                  if (result.returnmsg === 'Successful') {
                    console.log("TTTTTTTTTTTTTTTTTTT",this.resultData.Design_Styles.Measurment_Chart_Pending)
                    if(this.resultData.All_Designs.ALL_Designs=='' || this.resultData.All_Designs.ALL_Designs==null || this.resultData.All_Designs.ALL_Designs==undefined){
                      this.ALL_Designs= 0;
                    }
                    else{
                      this.ALL_Designs= this.resultData.All_Designs.ALL_Designs
                    }

                    if(this.resultData.Design_Styles.Measurment_Chart_Pending=='' || this.resultData.Design_Styles.Measurment_Chart_Pending==null || this.resultData.Design_Styles.Measurment_Chart_Pending==undefined){
                      this.Measurment_Chart_Pending= 0;
                    }
                    else{
                      this.Measurment_Chart_Pending= this.resultData.Design_Styles.Measurment_Chart_Pending;
                    }
                    if(this.resultData.Design_Styles.Measurement_Chart_Uploaded=='' || this.resultData.Design_Styles.Measurement_Chart_Uploaded==null || this.resultData.Design_Styles.Measurement_Chart_Uploaded==undefined){
                                  this.Measurement_Chart_Uploaded= 0;
                    }
                    else{
                      this.Measurement_Chart_Uploaded= this.resultData.Design_Styles.Measurement_Chart_Uploaded
                    }

                    if(this.resultData.Design_Styles.TRC_Upload_Pending=='' || this.resultData.Design_Styles.TRC_Upload_Pending==null || this.resultData.Design_Styles.TRC_Upload_Pending==undefined){
                                  this.TRC_Upload_Pending= 0;
                    }
                    else{
                      this.TRC_Upload_Pending= this.resultData.Design_Styles.TRC_Upload_Pending
                    }

                    if(this.resultData.Design_Styles.TRC_Uploaded=='' || this.resultData.Design_Styles.TRC_Uploaded==null || this.resultData.Design_Styles.TRC_Uploaded==undefined){
                                  this.TRC_Uploaded= 0;
                    }
                    else{
                      this.TRC_Uploaded= this.resultData.Design_Styles.TRC_Uploaded
                    }
                    if(this.resultData.Design_Styles.TAT_Breached=='' || this.resultData.Design_Styles.TAT_Breached==null || this.resultData.Design_Styles.TAT_Breached==undefined){
                                  this.TAT_Breached= 0;
                    }
                    else{
                      this.TAT_Breached= this.resultData.Design_Styles.TAT_Breached
                    }


                   
    
     
        }   
        
        })        
    },

    searchData:function(brand_id){
      console.log("selected_segment_id", this.selected_segment_id)
      this.updateFilters();
      this.displayDashboardData(brand_id);
    },

    // Search function api's

        /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // document.getElementById("overlay").style.display = "none";
              this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
               this.segmentList_arr = this.result.returnvalue;
              this.totalRows = this.segmentList_arr[0]["segment_list"].length;

              if (this.totalRows > 0) {
                this.segment_id = this.segmentList_arr[0]["segment_list"][0][
                  "segment_id"
                ];
                this.brand_id = this.segmentList_arr[0]["segment_list"][0][
                  "brand_id"
                ];
                //this.showCollection(this.brand_id, this.segment_id);
              }

            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id, segment_id) {
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];

      document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

             this.collectionData = response.data.returnvalue.collections;
             console.log("collections");
             console.log(this.collectionData)
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id) {
         // this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
          this.po_typearr = [];
          //document.getElementById("overlay").style.display = "block";
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)

          const Obj = {
            collection_id,
            user_id:  userInfo[0].user_id,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                this.sub_cat_id_arr = response.data.returnvalue;
              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },


        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id) {
      this.selected_po_id=null;
      
      //document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)

      // this.isBusy = true;
      const Obj = {
        subcat_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.po_typearr = this.result.returnvalue;
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
        console.log(filters);
        console.log(this.selected_po_id);
      },


    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];
      
      this.selected_segment_id = null,
        this.selected_collection_id = null,
        this.sub_catid = null,
        this.selected_po_id = null,
        localStorage.removeItem('filters');
        this.displayDashboardData();

    },

  }
};

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
      width: 150px;
  height: 140px;
  margin-left: 20px;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
   width: 150px;
  height: 140px;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
     width: 150px;
  height: 140px;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
       width: 150px;
  height: 140px;
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  width: 150px;
  height: 140px;
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}


</style>
